import { ActivityIcon, CpuIcon, GaugeIcon, PowerIcon, SettingsIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Electric Motor Fundamentals',
    summary: 'Electromagnetism, torque and back EMF, rotating magnetic field, synchronous speed and slip, motor construction, IP and IC codes, terminal markings, star and delta connections, motor types (induction, synchronous, PM, DC, single-phase), losses and efficiency classes.',
    icon: SettingsIcon,
  },
  {
    number: '2',
    title: 'Induction Motor Performance & Selection',
    summary: 'Torque–speed and current–speed curves, NEMA and IEC designs, effects of voltage, frequency and unbalance, load types, matching motor to load, inertia and acceleration time, duty types S1 to S10, sizing and selection.',
    icon: GaugeIcon,
  },
  {
    number: '3',
    title: 'Motor Starting, Control & Protection',
    summary: 'Inrush current and voltage dip, DOL, star-delta, autotransformer and soft starters, reversing and two-speed control, control circuits and ladder diagrams, contactors, overload relays, motor protection and coordination.',
    icon: PowerIcon,
  },
  {
    number: '4',
    title: 'Variable Frequency Drives (VFD)',
    summary: 'Affinity laws, rectifier, DC link and IGBT inverter, PWM and switching frequency, V/f, sensorless and closed-loop vector control, field weakening, drive sizing, key parameters, autotuning, harmonics, EMC and motor cable effects.',
    icon: CpuIcon,
  },
  {
    number: '5',
    title: 'Motor Testing & Condition Monitoring',
    summary: 'Maintenance strategies and the P-F curve, test safety, insulation resistance, PI and DAR, winding resistance, surge and hipot tests, motor circuit analysis, voltage and current balance, thermography, vibration and motor current analysis.',
    icon: ActivityIcon,
  },
  {
    number: '6',
    title: 'Maintenance, Troubleshooting & Reliability',
    summary: 'Inspection routines, cleaning and drying windings, bearing lubrication and failure modes, VFD bearing currents, alignment and soft foot, belt drives and couplings, winding and rotor failure patterns, systematic troubleshooting and reliability practices.',
    icon: WrenchIcon,
  },
];
